const text = value => String(value || "").replace(/\s+/g, " ").trim();

export const googleMapsUrlForPlace = place => {
  const name = text(place?.name);
  const location = text(place?.location);
  const query = [name, location].filter(Boolean).join(", ");
  if (!query) return null;
  const params = new URLSearchParams({ api: "1", query });
  const placeId = text(place?.gplace_id || place?.gplaceId || place?.metadata?.gplace_id);
  if (placeId) params.set("query_place_id", placeId);
  return `https://www.google.com/maps/search/?${params.toString()}`;
};

export const withCanonicalGoogleMapsUrl = place => ({
  ...place,
  maps: googleMapsUrlForPlace(place) || place?.maps || null,
});
